import React from "react";
import SidebarDesktop from "./Sidebar/SidebarDesktop";
import { MenuItem } from "./Managers/dataStructures";
import SidebarMobile from "./Sidebar/SidebarMobile";
import { getMenuListForUserRole } from "./Managers/dataProvider";
import { getUserAccess } from "./Managers/profileManager";

interface DashboardMenuProps {
  menuSelectionHandler: (selectionItem: MenuItem) => void;
  menuClose: () => void;
  isMenuOpen: boolean;
}

export default function DashboardMenu(props: DashboardMenuProps) {
  const array_menuItems_ = getMenuListForUserRole(getUserAccess());

  function closeMenu() {
    props.menuClose();
  }

  return (
    <div>
      <div className="relative z-50 lg:hidden" role="dialog" aria-modal="true">
        {/* Off-canvas menu backdrop, show/hide based on off-canvas menu state.
        Entering: "transition-opacity ease-linear duration-300" From:
        "opacity-0" To: "opacity-100" Leaving: "transition-opacity ease-linear
        duration-300" From: "opacity-100" To: "opacity-0" */}
        {/* <div className="fixed inset-0 bg-gray-900/80" aria-hidden="true"></div> */}

        {props.isMenuOpen ? (
          <div className="fixed inset-0 flex">
            <div className="relative mr-16 flex w-full flex-1 max-w-xs">
              {props.isMenuOpen ? menuCloseButton(closeMenu) : null}
              {props.isMenuOpen ? (
                <SidebarMobile
                  array_menuItems={array_menuItems_}
                  menuSelectionHandler={props.menuSelectionHandler}
                />
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
      {/* Static sidebar for desktop */}
      <SidebarDesktop
        array_menuItems={array_menuItems_}
        menuSelectionHandler={props.menuSelectionHandler}
      />
    </div>
  );
}

function menuCloseButton(menuClose: () => void) {
  return (
    <div className="absolute left-full top-0 flex w-16 justify-center pt-5">
      <button type="button" className="-m-2.5 p-2.5" onClick={menuClose}>
        <span className="sr-only">Close sidebar</span>
        <svg
          className="h-6 w-6 text-white"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            strokeLinejoin="round"
            strokeLinecap="round"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>
  );
}
